import rules from 'modules/rules'
import FormCommonMixin from 'mixins/formCommonMixin'
import selectMapMixin from 'mixins/selectMapMixin'
import dateOptionMixin from 'mixins/dateOptionMixin'
import { dateFormat } from 'modules/tools'

export default {
    props: {
        init: {
            type: Object,
            required: true
        }
    },
    mixins: [dateOptionMixin, FormCommonMixin, selectMapMixin],
    computed: {
        rangeStartDate () {
            return this.ruleForm.beginDate
        },
        postData () {
            let dataCopy = Object.assign({}, this.ruleForm)
            delete dataCopy.isEdit
            delete dataCopy._index
            return Object.assign(dataCopy, {
                'beginDate': dateFormat(this.ruleForm.beginDate),
                'endDate': dateFormat(this.ruleForm.endDate)
            })
        },
        durationDateText () {
            return this.ruleForm.beginDate ? dateFormat(this.ruleForm.beginDate, 'yyyy年MM月') + ' - ' + (this.ruleForm.endDate ? dateFormat(this.ruleForm.endDate, 'yyyy年MM月') : '至今') : '-'
        }
    },
    methods: {
        removeItem (itemData) {
            this.$emit('remove', itemData.id || itemData['_index'])
        },
        saveData (formName, callback) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    callback(this.postData)
                } else {
                    return false
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/resumeDetail/items/multiItemMixin.js